
    import './styles.scoped.css';
    export default {
  "runtime-content-wrapper": "awsui_runtime-content-wrapper_14m8x_1m9bu_5"
};
  